import { render, staticRenderFns } from "./PhoneDialog.vue?vue&type=template&id=f3189d9e&scoped=true&"
import script from "./PhoneDialog.vue?vue&type=script&lang=js&"
export * from "./PhoneDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhoneDialog.vue?vue&type=style&index=0&id=f3189d9e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3189d9e",
  null
  
)

export default component.exports